var React = require('react');

function GreyPlus (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"24","height":"24","fill":"#AEB5C0","rx":"12","key":0}),React.createElement("path",{"fill":"#fff","fillRule":"evenodd","d":"M13,11 L18,11 L18,13 L13,13 L13,18 L11,18 L11,13 L6,13 L6,11 L11,11 L11,6 L13,6 L13,11 Z","key":1})]);
}

GreyPlus.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = GreyPlus;

GreyPlus.default = GreyPlus;
